<template>
  <div>
    <img v-lazy="src"/>
  </div>
</template>

<script>
  import $           from 'jquery';
  import 'jquery-ui';
  import 'jquery-ui/themes/base/all.css';
  import 'jquery-ui/ui/widgets/dialog';
  import 'jquery-ui/ui/widgets/resizable';
  import Draggabilly from 'draggabilly';

  export default {
    name   : 'UiDialog',
    props  : ['src', 'hidden'],
    mounted() {
      const self = this;
      $(this.$el).dialog({
        classes: {
          'ui-dialog': 'ui-dialog-rosen',
        },
        draggable: false,
        appendTo : '#app-content',
        close    : function () {
          self.close();
        },
      });
      this.changePosition();
      this.changeSize();
      new Draggabilly('.ui-dialog-rosen', {
        handle     : '.ui-dialog-title',
        containment: '#app-content',
      });
      if ($('.ui-dialog').length === 1) {
        document.addEventListener('touchmove', this.touchMoveEventHandler, {passive: false});
      }
    },
    watch  : {
      hidden: function () {
        if (this.hidden) {
          this.close();
        } else {
          $(this.$el).dialog('open');
        }
      },
      src   : function () {
        this.changePosition();
        this.changeSize();
        $(this.$el).dialog('open');
      },
    },
    methods: {
      close() {
        $(this.$el).dialog('close');
        this.$emit('closed');
        $('.ui-dialog-rosen').remove();
        if ($('.ui-dialog').length === 0) {
          document.removeEventListener('touchmove', this.touchMoveEventHandler, {passive: false});
        }
      },
      changePosition() {
        $(this.$el).dialog('option', 'position', {my: 'left center', at: 'left center', of: '#app-content'});
      },
      changeSize() {
        const appContent = $('#app-content');
        if (appContent && appContent.length > 0) {
          const clientWidth  = appContent[0].clientWidth;
          const clientHeight = appContent[0].clientHeight;
          $(this.$el).dialog('option', 'height', clientHeight * 90 / 100);
          $(this.$el).dialog('option', 'width', clientWidth * 50 / 100);
        }
      },
      touchMoveEventHandler(event) {
        event.preventDefault();
      },
    },
  }
</script>

<style lang="scss" scoped>
</style>
